/* Shop Sweeper landing sections (ss-*): shared behaviour for all ss sections on a page. */
(function () {
  if (window.__ssInit) return;
  window.__ssInit = true;

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function scrollToEl(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - 8;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function onScreen(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight && r.height > 0;
  }

  /* ---- Buy box: selected variant, price and add to cart ---- */
  function selectedOption(picker) {
    var select = qs('[data-ss-variant]', picker);
    return select ? select.options[select.selectedIndex] : null;
  }

  function renderAtc(picker) {
    var atc = qs('[data-ss-atc]', picker);
    if (!atc) return;
    var state = atc.dataset.state || 'idle';
    var soldOut = atc.disabled && state === 'idle';
    qs('[data-ss-atc-label]', atc).textContent =
      soldOut ? (atc.dataset.soldOut || 'Sold out') :
      state === 'added' ? (atc.dataset.added || 'Added') :
      state === 'busy' ? (atc.dataset.adding || 'Adding…') :
      state === 'error' ? (atc.dataset.error || "Couldn't add — try again") :
      (atc.dataset.label || 'Add to cart');
    atc.classList.toggle('is-added', state === 'added');
  }

  /* Price box, button and gallery follow the variant picked in the dropdown */
  function applyVariant(picker) {
    var opt = selectedOption(picker);
    var atc = qs('[data-ss-atc]', picker);
    if (!opt || !atc) return;
    var price = opt.dataset.price;
    var was = opt.dataset.was;
    var save = opt.dataset.save;
    var priceEl = qs('[data-ss-price]', picker);
    var wasEl = qs('[data-ss-was]', picker);
    var saveEl = qs('[data-ss-save]', picker);
    var discountEl = qs('[data-ss-discount]', picker);
    if (priceEl) priceEl.textContent = price;
    if (wasEl) wasEl.textContent = was || '';
    if (saveEl) {
      saveEl.hidden = !save;
      var label = saveEl.dataset.template || 'Save';
      saveEl.textContent = label.indexOf('[save]') > -1 ? label.replace('[save]', save || '') : label + ' ' + (save || '');
    }
    if (discountEl) discountEl.hidden = !save;
    qs('[data-ss-atc-price]', atc).textContent = price;
    atc.dataset.variantId = opt.value;
    atc.dataset.amount = opt.dataset.amount;
    atc.disabled = opt.dataset.available !== 'true';
    atc.dataset.state = 'idle';
    renderAtc(picker);
    showVariantMedia(picker, opt.dataset.mediaId);
  }

  /* The theme's cart drawer / cart notification element, when the theme cart type uses one */
  function themeCart(picker) {
    if (picker.dataset.cartType === 'page') return null;
    var cart = qs('cart-drawer') || qs('cart-notification');
    return cart && typeof cart.renderContents === 'function' ? cart : null;
  }

  /* Cart drawer apps (UpCart) replace the theme drawer and open themselves when an item is added */
  function openAppCart() {
    var hasUpcart = typeof window.upcartOpenCart === 'function' || !!window.upcartSettings;
    if (!hasUpcart) return false;
    try {
      if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
      if (typeof window.upcartOpenCart === 'function') window.upcartOpenCart();
    } catch (err) { /* the app opens its drawer on its own after /cart/add */ }
    return true;
  }

  function addToCart(picker, atc) {
    var state = atc.dataset.state || 'idle';
    if (atc.disabled || state === 'busy' || state === 'added') return;
    var setState = function (next) { atc.dataset.state = next; renderAtc(picker); };
    var behavior = picker.dataset.addBehavior || 'cart';
    var cart = behavior === 'theme' ? themeCart(picker) : null;
    var payload = { id: Number(atc.dataset.variantId), quantity: 1 };
    if (cart) {
      /* Ask Shopify for the re-rendered cart sections so the drawer can update without a page load */
      payload.sections = cart.getSectionsToRender().map(function (section) { return section.id; });
      payload.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(atc);
    }
    setState('busy');
    fetch(picker.dataset.addUrl || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (data) {
        setState('added');
        if (behavior === 'checkout') { window.location.href = '/checkout'; return; }
        var stay = false;
        if (cart) {
          try { cart.renderContents(data); stay = true; } catch (err) { /* fall through */ }
        }
        if (!stay && behavior === 'theme' && picker.dataset.cartType !== 'page') stay = openAppCart();
        if (stay) {
          setTimeout(function () { setState('idle'); }, 2000);
          return;
        }
        window.location.href = picker.dataset.cartUrl || '/cart';
      })
      .catch(function () {
        setState('error');
        setTimeout(function () { setState('idle'); }, 2000);
      });
  }

  /* ---- Gallery: swipe the main media or tap a thumbnail ---- */
  function slidesOf(gallery) { return qsa('[data-ss-slide]', gallery); }
  function activeIndex(gallery) { return Number(gallery.dataset.index || 0); }

  function setActiveSlide(gallery, index) {
    var slides = slidesOf(gallery);
    if (!slides.length) return;
    index = Math.max(0, Math.min(index, slides.length - 1));
    gallery.dataset.index = index;
    var thumbsBox = qs('.ss-gallery__thumbs', gallery);
    qsa('[data-ss-thumb]', gallery).forEach(function (t, i) {
      var on = i === index;
      t.classList.toggle('is-active', on);
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      if (on && thumbsBox) {
        /* centre the active thumbnail, measured inside the thumbnail row (never past the start) */
        var offset = t.getBoundingClientRect().left - thumbsBox.getBoundingClientRect().left + thumbsBox.scrollLeft;
        thumbsBox.scrollLeft = Math.max(0, offset - (thumbsBox.clientWidth - t.offsetWidth) / 2);
      }
    });
    var count = qs('[data-ss-count]', gallery);
    if (count) count.textContent = (index + 1) + ' / ' + slides.length;
    slides.forEach(function (slide, i) {
      var video = qs('video', slide);
      if (!video) return;
      if (i === index) {
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  function goToSlide(gallery, index, instant) {
    var track = qs('[data-ss-slides]', gallery);
    var slides = slidesOf(gallery);
    if (!track || !slides.length) return;
    index = Math.max(0, Math.min(index, slides.length - 1));
    gallery.ssTarget = index;
    clearTimeout(gallery.ssTimer);
    gallery.ssTimer = setTimeout(function () { gallery.ssTarget = null; }, 700);
    setActiveSlide(gallery, index);
    var left = slides[index].offsetLeft - slides[0].offsetLeft;
    if (instant || typeof track.scrollTo !== 'function') track.scrollLeft = left;
    else track.scrollTo({ left: left, behavior: 'smooth' });
  }

  function showVariantMedia(picker, mediaId) {
    var gallery = qs('[data-ss-gallery]', picker);
    if (!gallery || !mediaId) return;
    var slides = slidesOf(gallery);
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].dataset.mediaId === mediaId) { goToSlide(gallery, i); return; }
    }
  }

  function bindGallery(gallery) {
    var track = qs('[data-ss-slides]', gallery);
    if (!track || track.ssBound) return;
    track.ssBound = true;
    track.addEventListener('scroll', function () {
      if (!track.clientWidth) return;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      if (gallery.ssTarget != null) {
        if (index === gallery.ssTarget) gallery.ssTarget = null;
        return;
      }
      if (index !== activeIndex(gallery)) setActiveSlide(gallery, index);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      goToSlide(gallery, activeIndex(gallery) + (e.key === 'ArrowRight' ? 1 : -1));
    });
    setActiveSlide(gallery, activeIndex(gallery));
  }

  /* ---- FAQ: one answer open at a time within a list ---- */
  function toggleFaq(q) {
    var open = q.getAttribute('aria-expanded') === 'true';
    qsa('[data-ss-faq]', q.closest('[data-ss-faq-list]') || document).forEach(function (other) {
      var on = other === q && !open;
      other.setAttribute('aria-expanded', on ? 'true' : 'false');
      var panel = document.getElementById(other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !on;
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('[data-ss-goto],[data-ss-thumb],[data-ss-nav],[data-ss-atc],[data-ss-faq]');
    if (!el) return;
    if (el.hasAttribute('data-ss-goto')) {
      /* "Claim my offer" buttons go to the buy box, the rating goes to the comments */
      var target = el.dataset.ssGoto === 'reviews' ? qs('[data-ss-reviews]') : qs('[data-ss-picker]');
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
    } else if (el.hasAttribute('data-ss-thumb') || el.hasAttribute('data-ss-nav')) {
      var gallery = el.closest('[data-ss-gallery]');
      if (!gallery) return;
      if (el.hasAttribute('data-ss-thumb')) goToSlide(gallery, qsa('[data-ss-thumb]', gallery).indexOf(el));
      else {
        /* arrows loop around, like the product page */
        var total = slidesOf(gallery).length;
        goToSlide(gallery, (activeIndex(gallery) + Number(el.dataset.ssNav) + total) % total);
      }
    } else if (el.hasAttribute('data-ss-atc')) {
      var picker = el.closest('[data-ss-picker]');
      if (picker) addToCart(picker, el);
    } else {
      toggleFaq(el);
    }
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-ss-variant]')) return;
    var picker = e.target.closest('[data-ss-picker]');
    if (picker) applyVariant(picker);
  });

  /* ---- Sticky bar: shown once the hero and comments are scrolled past, hidden while the buy box is on screen ---- */
  function updateBars() {
    var bars = qsa('[data-ss-bar]');
    if (!bars.length) return;
    var show = !qsa('[data-ss-top],[data-ss-picker]').some(onScreen);
    bars.forEach(function (bar) {
      if (bar.hasAttribute('data-ss-preview')) return;
      if (show === bar.classList.contains('is-visible')) return;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      qsa('a,button', bar).forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    });
  }

  /* Product view for Meta: a landing page sends no ViewContent on its own, so send one the first time
     the buy box is on screen. Skipped until the pixel has loaded and in the theme editor. */
  function trackViews() {
    if (window.Shopify && window.Shopify.designMode) return;
    qsa('[data-ss-picker][data-track-view]').forEach(function (picker) {
      if (picker.ssViewed || !onScreen(picker) || typeof window.fbq !== 'function') return;
      picker.ssViewed = true;
      var atc = qs('[data-ss-atc]', picker);
      var data = {
        content_ids: [String(picker.dataset.productId)],
        content_type: 'product_group',
        content_name: picker.dataset.productTitle || ''
      };
      var amount = atc && parseFloat(atc.dataset.amount);
      if (amount && picker.dataset.currency) { data.value = amount; data.currency = picker.dataset.currency; }
      try { window.fbq('track', 'ViewContent', data); } catch (err) { /* never let tracking break the page */ }
    });
  }

  /* ---- Sale end dates: today + N days in the visitor's own calendar, so cached pages stay current ---- */
  function updateDates() {
    qsa('[data-ss-date]').forEach(function (el) {
      var d = new Date();
      d.setDate(d.getDate() + Number(el.dataset.ssDays || 0));
      var opts = el.dataset.ssDate === 'short' ? { month: 'long', day: 'numeric' } : { weekday: 'long', month: 'long', day: 'numeric' };
      try { el.textContent = d.toLocaleDateString('en-US', opts); } catch (err) { /* keep the server-rendered date */ }
    });
  }

  function onScrollOrResize() { updateBars(); trackViews(); }

  function init() {
    updateDates();
    qsa('[data-ss-picker]').forEach(function (picker) {
      renderAtc(picker);
      qsa('[data-ss-gallery]', picker).forEach(bindGallery);
    });
    updateBars();
    trackViews();
  }

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);
  /* Reset add-to-cart buttons when the page is restored from the back/forward cache */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    qsa('[data-ss-atc]').forEach(function (atc) { atc.dataset.state = 'idle'; });
    init();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
